<!-- START OF MAIN -->
<main class="site-main">
    <!-- START OF BANNER -->
    <section class="inner-banner back-img" style="background-image: url('assets/img/about-us-banner-new.jpg');">
        <div class="banner-stripes">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="banner-shape-wp wow fadeInRight for-des" data-wow-duration=".8s">
            <div class="banner-shape">
                <span class="stripe"></span>
                <span class="stripe stripe-secondary"></span>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="inner-banner-content-wp white-text text-center">
                        <div class="inner-banner-content wow fadeInUp" data-wow-duration=".8s">
                            <h2 class="h2-title mb-0 mt-5">Frequently Asked Questions</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF BANNER -->
    <!-- START OF SERVICES LISTING -->
    <section class="faq-section light-bg">
        <div class="container faq-main-page">
            <div class="row">
                <div class="col-12">
                    <div class="faq-content wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="accordion" id="accordionExample">
                            <div class="accordion-item mb-3" *ngFor="let faq of faqList; let i = index;">
                                <div class="accordion-header">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne" aria-expanded="true" [attr.aria-controls]="i" (click)="activeFaq(faq?.id)">
                                        <h3 class="mb-0">{{faq?.question}}</h3>
                                    </button>
                                </div>
                                <div id="{{i}}" class="accordion-collapse collapse" [ngClass]="{ 'show': faqId == faq?.id }"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        {{faq?.answer}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>